/**
 * Created by Ning Jiang on 2023-09-01.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";

export class DCRoadAvalancheBetPresentation implements FlowStatePresentation {

    constructor() {}

    public start(flowStateController:FlowStateController) {
        DevilsCrossRoad.totalWinCountUp.remove();
        DevilsCrossRoad.bigWinCountUp.remove();
        DevilsCrossRoad.multipliers.setAll(DevilsCrossRoad.model.nextQuadMultiplier, false, true);
        DevilsCrossRoad.devil.playAvalancheSpin();
        DevilsCrossRoad.backgroundElements.setMainFrame("glow_slow", true);

        const promises:Promise<any>[] = [];
        promises.push(DevilsCrossRoad.reels.startSpin(true));
        DevilsCrossRoad.scatters.tryStartScatterNearWin();

        Promise.all(promises).then(res => flowStateController.finish());
    }
}